import { Component, OnInit, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BaseComponent } from '../../../base/base-component.component';
import { SiteSettingModel, DynamicContentSchemaFactory, MenuModel, MenuItemModel, MenuItemDto, PageFacade, PageModel, MenuItemFacade, DynamicContentSchemaFacade } from '../../../services';
import { DefaultContents, AppToken } from '../../../models/app-token';
import { Router} from '@angular/router';

@Component({
  selector: 'menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.css']
})
export class MenuComponent extends BaseComponent implements OnInit {

  @Input()
  siteSettingModel: SiteSettingModel;

  @Input()
  menuCode: string;

  menuItemFacade: DynamicContentSchemaFacade;

  menu: MenuModel;
  menuItemDtos: Array<MenuItemDto>;
  rootMenuItemDtos: Array<MenuItemDto>;
  menuTitle = '';
  pages: PageModel[];
  currentLink: string;

  constructor(
    private readonly contentFacadeFactory: DynamicContentSchemaFactory,
    private readonly pageFacade: PageFacade,
    private readonly router: Router,
    translateService: TranslateService
  ) {
    super(translateService);
    this.setTranslateContext('MenuComponent');
  }

  ngOnInit() {
    const menuFacade = this.contentFacadeFactory.getDynamicContentSchemaFacade(AppToken.MENU_SCHEMA_NAME);

    const sub = menuFacade.getByCode(DefaultContents.DEFAULT_MENU_CODE).subscribe(m => {
      this.menu = m;
      this.menuTitle = this.dParser.pullData(m, 'name', this.getCurrentCulture());
    });

    this.subscriptions.push(sub);

    const urlPart = '/page'
    this.currentLink = this.router.url.substring(this.router.url.indexOf(urlPart) + urlPart.length);


    this.menuItemFacade = this.contentFacadeFactory.getDynamicContentSchemaFacade(AppToken.MENU_ITEM_SCHEMA_NAME);

    const subPage = this.pageFacade.getAll().subscribe(pg => {

      this.pages = pg;

      const sub2 = this.menuItemFacade.getAll().subscribe(mi => {

        const dtoList: MenuItemDto[] = [];

        mi.forEach(m => {
          const itemDto = new MenuItemDto();
          itemDto.menuItem = m;
          const link = this.dParser.pullData(m, 'link', this.getCurrentCulture());
          if (link) {
            itemDto.isCurrentPage = this.isCurrentMenuLink(m);
          } else if (m.data.page) {
            const page = this.pages.find(p => p.id === m.data.page.iv);
            if (page) {
              itemDto.isCurrentPage = this.isCurrentPage(page);
            } else {
              itemDto.isCurrentPage = this.isCurrentMenuCode(m);
            }
          }
          else {
            itemDto.isCurrentPage = this.isCurrentMenuCode(m);
          }

          const parentMi = dtoList.find(o => o.menuItem.id === itemDto.menuItem.id);
          if (!parentMi) {
            dtoList.push(itemDto);
          }

          if (itemDto.isCurrentPage && m.data.parentMenuItem.iv.length > 0) {

            this.addParentToList(mi, m, dtoList);

          }
        });

        this.menuItemDtos = dtoList.sort((a, b) => {
          if (!a.menuItem.data) {
            return 1;
          }
          if (!b.menuItem.data) {
            return 1;
          }
          if (!a.menuItem.data.index) {
            return 1;
          }
          if (!b.menuItem.data.index) {
            return 1;
          }
          return a.menuItem.data.index.iv < b.menuItem.data.index.iv ? -1 : 1
        });

        this.rootMenuItemDtos = this.menuItemDtos.filter(v => v.menuItem.data.parentMenuItem.iv.length === 0);

      });

      this.subscriptions.push(sub2);

    });

    this.subscriptions.push(subPage);
  }

  addParentToList(mi: MenuItemModel[], m: MenuItemModel, dtoList: MenuItemDto[]) {
    const parentMi = mi.find(o => o.id === m.data.parentMenuItem.iv[0]);
    if (parentMi) {
      let exists = true;
      let parent = dtoList.find(o => o.menuItem.id === parentMi.id);
      if (!parent) {
        parent = new MenuItemDto();
        parent.menuItem = parentMi;
        exists = false;
      }
      parent.isCurrentPage = true;
      if (exists) {
        const index = dtoList.findIndex(o => o.menuItem.id === parentMi.id);
        dtoList[index] = parent;
      } else {
        dtoList.push(parent);
      }
      this.addParentToList(mi, parentMi, dtoList);
    }
  }

  isCurrentMenuLink(menu: MenuItemModel) {
    const link = this.dParser.pullData(menu, 'link', this.getCurrentCulture());
    if (link.replace('/', '') === this.currentLink.replace('/', '')) {
      return true;
    } else {
      return false;
    }
  }

  isCurrentMenuCode(menu: MenuItemModel) {
    const code = this.dParser.pullData(menu, 'code');
    if (code === this.currentLink.substring(this.currentLink.lastIndexOf('/') + 1)) {
      return true;
    } else {
      return false;
    }
  }

  isCurrentPage(page: PageModel): boolean {
    const link = this.dParser.pullData(page, 'url', this.getCurrentCulture());
    const code = this.dParser.pullData(page, 'code');
    if (link === this.currentLink) {
      return true;
    } else if (code.replace('/', '') === this.currentLink.replace('/', '')) {
      return true;
    } else {
      return false;
    }
  }

  menuItemeDrop(event) {
    const menuItemsIdOrdered: MenuItemDto[] = this.clone(this.rootMenuItemDtos);

    if (event['previousIndex'] === event['currentIndex']) {
      return;
    }

    let menus = [];
    const indexFrom = event['previousIndex'];
    const indexTo = event['currentIndex'];

    if (indexFrom === indexTo) {
      return;
    }

    const isUp = indexFrom > indexTo;

    if (isUp) {
      for (let i = 0; i < menuItemsIdOrdered.length; i++) {
        if (i < indexTo) {
          this.dParser.putData(menuItemsIdOrdered[i].menuItem.data, 'index', i);
          menus.push(menuItemsIdOrdered[i]);
        } else if (i === indexTo) {
          this.dParser.putData(menuItemsIdOrdered[indexFrom].menuItem.data, 'index', i);
          this.dParser.putData(menuItemsIdOrdered[indexTo].menuItem.data, 'index', i + 1);
          menus.push(menuItemsIdOrdered[indexFrom]);
          menus.push(menuItemsIdOrdered[indexTo]);
        } else if (i != indexFrom) {
          this.dParser.putData(menuItemsIdOrdered[indexTo].menuItem.data, 'index', i);
          menus.push(menuItemsIdOrdered[i]);
        }
      }
    } else {
      for (let i = menuItemsIdOrdered.length - 1; i >= 0; i--) {
        if (i > indexTo) {
          this.dParser.putData(menuItemsIdOrdered[i].menuItem.data, 'index', i);
          menus.push(menuItemsIdOrdered[i]);
        } else if (i === indexTo) {
          this.dParser.putData(menuItemsIdOrdered[indexFrom].menuItem.data, 'index', i);
          this.dParser.putData(menuItemsIdOrdered[indexTo].menuItem.data, 'index', i - 1);
          menus.push(menuItemsIdOrdered[indexFrom]);
          menus.push(menuItemsIdOrdered[indexTo]);
        } else if (i !== indexFrom) {
          this.dParser.putData(menuItemsIdOrdered[indexTo].menuItem.data, 'index', i);
          menus.push(menuItemsIdOrdered[i]);
        }
      }
      menus = menus.reverse();
    }

    this.rootMenuItemDtos = menus;

    for (let i = 0; i < menus.length; i++) {
      const menuItemId = menus[i].menuItem.id;
      const sub = this.menuItemFacade.get(menuItemId).subscribe(menuItem => {
        const menuItemData = this.clone(menuItem.data);
        this.dParser.putData(menuItemData, 'index', i);
        this.menuItemFacade.update(menuItemId, menuItemData).subscribe();
        this.subscriptions.push(sub);
      });
    }
  }

  menuItemeDropChild(event: any) {

    if (event['previousIndex'] == event['currentIndex']) {
      return;
    }

    const menuItems: MenuItemDto[] = this.clone(this.menuItemDtos);

    const parentMenuId = event.container.element.nativeElement.id.substring(3);
    const menusFromParent: MenuItemDto[] = menuItems.filter(m => m.menuItem.data.parentMenuItem.iv[0] === parentMenuId);

    let menus = [];

    const indexFrom = event['previousIndex'];
    const indexTo = event['currentIndex'];
    const isUp = indexFrom > indexTo;

    if (indexFrom === indexTo) {
      return;
    }

    if (isUp) {
      for (let i = 0; i < menusFromParent.length; i++) {
        if (i < indexTo) {
          this.dParser.putData(menusFromParent[i].menuItem.data, 'index', i);
          menus.push(menusFromParent[i]);
        } else if (i === indexTo) {
          this.dParser.putData(menusFromParent[indexFrom].menuItem.data, 'index', i);
          this.dParser.putData(menusFromParent[indexTo].menuItem.data, 'index', i + 1);
          menus.push(menusFromParent[indexFrom]);
          menus.push(menusFromParent[indexTo]);
        } else if (i !== indexFrom) {
          this.dParser.putData(menusFromParent[indexTo].menuItem.data, 'index', i);
          menus.push(menusFromParent[i]);
        }
      }
    } else {
      for (let i = menusFromParent.length - 1 ; i >= 0; i--) {
        if (i > indexTo) {
          this.dParser.putData(menusFromParent[i].menuItem.data, 'index', i);
          menus.push(menusFromParent[i]);
        } else if (i === indexTo) {
          this.dParser.putData(menusFromParent[indexFrom].menuItem.data, 'index', i);
          this.dParser.putData(menusFromParent[indexTo].menuItem.data, 'index', i - 1);
          menus.push(menusFromParent[indexFrom]);
          menus.push(menusFromParent[indexTo]);
        } else if (i !== indexFrom) {
          this.dParser.putData(menusFromParent[indexTo].menuItem.data, 'index', i);
          menus.push(menusFromParent[i]);
        }
      }
      menus = menus.reverse();
    }

    menus.forEach(mp => {
      const i: number = menuItems.findIndex(m => m.menuItem.id === mp.menuItem.id);
      if (i >= 0) {
        menuItems[i] = mp;
      }
    });

    const pIndex: number = menuItems.findIndex(m => m.menuItem.id === menus[indexTo].menuItem.data.parentMenuItem.iv[0]);
    menuItems[pIndex].isCurrentPage = true;

    for (let i = 0; i < menus.length; i++) {
      const menuItemId = menus[i].menuItem.id;
      const sub = this.menuItemFacade.get(menuItemId).subscribe(menuItem => {
        const menuItemData = this.clone(menuItem.data);
        this.dParser.putData(menuItemData, 'index', i);
        const sub2 = this.menuItemFacade.update(menuItemId, menuItemData).subscribe();
        this.subscriptions.push(sub2);
      });
      this.subscriptions.push(sub);
    }

    this.menuItemDtos = menuItems.sort((a, b) => a.menuItem.data.index.iv < b.menuItem.data.index.iv ? -1 : 1);
    this.rootMenuItemDtos = this.menuItemDtos.filter(v => v.menuItem.data.parentMenuItem.iv.length === 0);
  }
}
